// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  /* Green */
  --green-25: #F5FCED;
  --green-50: #F3FAEB;
  --green-100: #E2F2D5;
  --green-200: #C9E7AF;
  --green-300: #A6D680;
  --green-400: #83C35F;
  --green-500: #65A843;
  --green-600: #487C2F;
  --green-700: #3D662A;
  --green-800: #335126;
  --green-900: #2D4723;
  --green-950: #14260E;

  /* Grey */
  --grey-0: #FFFFFF;
  --grey-25: #FAFAFA;
  --grey-50: #E7E8E8;
  --grey-100: #E8EAEA;
  --grey-200: #D1D4D4;
  --grey-300: #B0B5B5;
  --grey-400: #8C9393;
  --grey-500: #6B7474;
  --grey-600: #525C5C;
  --grey-700: #3D4747;
  --grey-800: #384040;
  --grey-900: #202626;
  --grey-950: #080A0A;

  /* Gold */
  --gold-50: #F9F7ED;
  --gold-100: #F1EBD2;
  --gold-200: #E3D7A6;
  --gold-300: #D5BB74;
  --gold-400: #C6A150;
  --gold-500: #B88D43;
  --gold-600: #9E7037;
  --gold-700: #7B512C;
  --gold-800: #6A462B;
  --gold-900: #5D3B29;
  --gold-950: #351F14;

  /* Maroon */
  --maroon-50: #FCF3F3;
  --maroon-100: #FFE5E5;
  --maroon-200: #E9AAAA;
  --maroon-300: #DF8686;
  --maroon-400: #D46363;
  --maroon-500: #C94040;
  --maroon-600: #A83333;
  --maroon-700: #832A2A;
  --maroon-800: #5F2121;
  --maroon-900: #3C1616;
  --maroon-950: #1A0A0A;
}

/* Semantic tokens. Themed once here so components can use them without
   repeating the light / explicit-dark / system-dark selector triple. */
:root {
  --bg: var(--grey-25);
  --surface: var(--grey-0);
  --surface-alt: var(--grey-25);
  --border: var(--grey-50);
  --text: var(--grey-950);
  --text-secondary: var(--grey-600);
  --text-muted: var(--grey-500);
  --accent-light: var(--green-100);
  --accent-subtle: var(--green-100);
  --accent-medium: var(--green-200);
  --accent: var(--green-400);
  --accent-strong: var(--green-500);
  --accent-soft: var(--green-25);
  --accent-text: var(--grey-950);
  --positive: var(--green-600);
  --track: var(--grey-200);
}

:root[data-theme="dark"] {
  --bg: var(--grey-950);
  --surface: var(--grey-900);
  --surface-alt: var(--grey-950);
  --border: var(--grey-800);
  --text: var(--grey-0);
  --text-secondary: var(--grey-200);
  --text-muted: var(--grey-400);
  --accent-light: var(--green-800);
  --accent-subtle: var(--green-800);
  --accent-medium: var(--green-700);
  --accent: var(--green-400);
  --accent-strong: var(--green-300);
  --accent-soft: var(--green-900);
  --accent-text: var(--grey-950);
  --positive: var(--green-200);
  --track: var(--grey-700);
}

@media (prefers-color-scheme: dark) {
  :root:not([data-theme="light"]) {
    --bg: var(--grey-950);
    --surface: var(--grey-900);
    --surface-alt: var(--grey-950);
    --border: var(--grey-800);
    --text: var(--grey-0);
    --text-secondary: var(--grey-200);
    --text-muted: var(--grey-400);
    --accent-light: var(--green-800);
    --accent-subtle: var(--green-800);
    --accent-medium: var(--green-700);
    --accent: var(--green-400);
    --accent-strong: var(--green-300);
    --accent-soft: var(--green-900);
    --accent-text: var(--grey-950);
    --positive: var(--green-200);
    --track: var(--grey-700);
  }
}

:root {
  background-color: var(--bg);
}

body {
  margin: 0;
  font-family: 'Montserrat', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: var(--bg);
  color: var(--text);
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;;EAEpB,SAAS;EACT,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;;EAEnB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;;EAEnB,WAAW;EACX,oBAAoB;EACpB,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;uEACuE;AACvE;EACE,oBAAoB;EACpB,wBAAwB;EACxB,6BAA6B;EAC7B,wBAAwB;EACxB,uBAAuB;EACvB,iCAAiC;EACjC,6BAA6B;EAC7B,gCAAgC;EAChC,iCAAiC;EACjC,iCAAiC;EACjC,0BAA0B;EAC1B,iCAAiC;EACjC,8BAA8B;EAC9B,8BAA8B;EAC9B,4BAA4B;EAC5B,wBAAwB;AAC1B;;AAEA;EACE,qBAAqB;EACrB,0BAA0B;EAC1B,8BAA8B;EAC9B,yBAAyB;EACzB,qBAAqB;EACrB,iCAAiC;EACjC,6BAA6B;EAC7B,gCAAgC;EAChC,iCAAiC;EACjC,iCAAiC;EACjC,0BAA0B;EAC1B,iCAAiC;EACjC,+BAA+B;EAC/B,8BAA8B;EAC9B,4BAA4B;EAC5B,wBAAwB;AAC1B;;AAEA;EACE;IACE,qBAAqB;IACrB,0BAA0B;IAC1B,8BAA8B;IAC9B,yBAAyB;IACzB,qBAAqB;IACrB,iCAAiC;IACjC,6BAA6B;IAC7B,gCAAgC;IAChC,iCAAiC;IACjC,iCAAiC;IACjC,0BAA0B;IAC1B,iCAAiC;IACjC,+BAA+B;IAC/B,8BAA8B;IAC9B,4BAA4B;IAC5B,wBAAwB;EAC1B;AACF;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,SAAS;EACT,qCAAqC;EACrC,mCAAmC;EACnC,kCAAkC;EAClC,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE;aACW;AACb","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap');\n\n:root {\n  /* Green */\n  --green-25: #F5FCED;\n  --green-50: #F3FAEB;\n  --green-100: #E2F2D5;\n  --green-200: #C9E7AF;\n  --green-300: #A6D680;\n  --green-400: #83C35F;\n  --green-500: #65A843;\n  --green-600: #487C2F;\n  --green-700: #3D662A;\n  --green-800: #335126;\n  --green-900: #2D4723;\n  --green-950: #14260E;\n\n  /* Grey */\n  --grey-0: #FFFFFF;\n  --grey-25: #FAFAFA;\n  --grey-50: #E7E8E8;\n  --grey-100: #E8EAEA;\n  --grey-200: #D1D4D4;\n  --grey-300: #B0B5B5;\n  --grey-400: #8C9393;\n  --grey-500: #6B7474;\n  --grey-600: #525C5C;\n  --grey-700: #3D4747;\n  --grey-800: #384040;\n  --grey-900: #202626;\n  --grey-950: #080A0A;\n\n  /* Gold */\n  --gold-50: #F9F7ED;\n  --gold-100: #F1EBD2;\n  --gold-200: #E3D7A6;\n  --gold-300: #D5BB74;\n  --gold-400: #C6A150;\n  --gold-500: #B88D43;\n  --gold-600: #9E7037;\n  --gold-700: #7B512C;\n  --gold-800: #6A462B;\n  --gold-900: #5D3B29;\n  --gold-950: #351F14;\n\n  /* Maroon */\n  --maroon-50: #FCF3F3;\n  --maroon-100: #FFE5E5;\n  --maroon-200: #E9AAAA;\n  --maroon-300: #DF8686;\n  --maroon-400: #D46363;\n  --maroon-500: #C94040;\n  --maroon-600: #A83333;\n  --maroon-700: #832A2A;\n  --maroon-800: #5F2121;\n  --maroon-900: #3C1616;\n  --maroon-950: #1A0A0A;\n}\n\n/* Semantic tokens. Themed once here so components can use them without\n   repeating the light / explicit-dark / system-dark selector triple. */\n:root {\n  --bg: var(--grey-25);\n  --surface: var(--grey-0);\n  --surface-alt: var(--grey-25);\n  --border: var(--grey-50);\n  --text: var(--grey-950);\n  --text-secondary: var(--grey-600);\n  --text-muted: var(--grey-500);\n  --accent-light: var(--green-100);\n  --accent-subtle: var(--green-100);\n  --accent-medium: var(--green-200);\n  --accent: var(--green-400);\n  --accent-strong: var(--green-500);\n  --accent-soft: var(--green-25);\n  --accent-text: var(--grey-950);\n  --positive: var(--green-600);\n  --track: var(--grey-200);\n}\n\n:root[data-theme=\"dark\"] {\n  --bg: var(--grey-950);\n  --surface: var(--grey-900);\n  --surface-alt: var(--grey-950);\n  --border: var(--grey-800);\n  --text: var(--grey-0);\n  --text-secondary: var(--grey-200);\n  --text-muted: var(--grey-400);\n  --accent-light: var(--green-800);\n  --accent-subtle: var(--green-800);\n  --accent-medium: var(--green-700);\n  --accent: var(--green-400);\n  --accent-strong: var(--green-300);\n  --accent-soft: var(--green-900);\n  --accent-text: var(--grey-950);\n  --positive: var(--green-200);\n  --track: var(--grey-700);\n}\n\n@media (prefers-color-scheme: dark) {\n  :root:not([data-theme=\"light\"]) {\n    --bg: var(--grey-950);\n    --surface: var(--grey-900);\n    --surface-alt: var(--grey-950);\n    --border: var(--grey-800);\n    --text: var(--grey-0);\n    --text-secondary: var(--grey-200);\n    --text-muted: var(--grey-400);\n    --accent-light: var(--green-800);\n    --accent-subtle: var(--green-800);\n    --accent-medium: var(--green-700);\n    --accent: var(--green-400);\n    --accent-strong: var(--green-300);\n    --accent-soft: var(--green-900);\n    --accent-text: var(--grey-950);\n    --positive: var(--green-200);\n    --track: var(--grey-700);\n  }\n}\n\n:root {\n  background-color: var(--bg);\n}\n\nbody {\n  margin: 0;\n  font-family: 'Montserrat', sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  background-color: var(--bg);\n  color: var(--text);\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
